import axios from "./axios_c";

class Base {
}

export default Base;